import type { IETFLanguageTag } from '@opallabs/concepts'

/**
 * Test whether a given string is a valid locale.
 */
export const validateLocale = (locale: IETFLanguageTag): boolean => {
  try {
    ensureValidLocale(locale)
  } catch (e) {
    if (e instanceof RangeError) {
      return false
    }

    throw e
  }

  return true
}

/**
 * No return value, but throws an error if `locale` is not a valid locale
 * identifier.
 */
export function ensureValidLocale(locale: IETFLanguageTag) {
  Intl.getCanonicalLocales(locale)
}
